module.exports = __webpack_public_path__ + "static/media/personal-family-assistant.b6937711.jpg";